import { getDeviceInfo } from "../CommonHooks";

export const noop = () => {};
export function on(obj, ...args) {
    if (obj && obj.addEventListener) {
        obj.addEventListener(...args);
    }
}
export function off(obj, ...args) {
    if (obj && obj.removeEventListener) {
        obj.removeEventListener(...args);
    }
}
export const isBrowser = typeof window !== 'undefined';
export const isNavigator = typeof navigator !== 'undefined';

export const errRedirectPage= (err)=>{ 
    console.error(err);
    if(process.env.NODE_ENV!=='development'){
         window.location.assign(`https://common.hkjc.com/maint/generic.html`);
    }else{
        return ;
    }
}

export const obj2cookie = (obj) => JSON.stringify(obj).replace(/\"/gi, '');
export const cookie2obj = (cookie) => JSON.parse(cookie?.replace(/([\w\-]+):/gi, '"$1":'));

export const checkIsSameDay = (date1, date2) => {
    if (!date1 || !date2) {
        return false;
    }

    return (
        (date1.getFullYear() === date2.getFullYear()) &&
        (date1.getMonth() === date2.getMonth()) &&
        (date1.getDate() === date2.getDate())
    );
};

export const isValidIdentityEnName = (name) => /^([A-Za-z.'-]+)(\s[A-Za-z.'-]+)*$/.test(name);
export const isValidIdentityChName = (name) => /^[^\x01-\x1F\x0A\x0D&\\;]*$/.test(name);
const getBrowserLanguage = () => {
    const browserLanguage = navigator.language || navigator.userLanguage;
    return browserLanguage.startsWith('zh') ? 'ch' : 'en';
};

export const getDefaultLanguage = (cookieLanguage) => {
    const pathnameList = window.location.pathname.split('/');
    if (pathnameList.includes('betlite') && !pathnameList.includes('en') &&  !pathnameList.includes('ch')) {
        if (window.cashBetConfig.enableIDVFlow && getDeviceInfo().isDesktop && !location.pathname.endsWith('/desktop')) {
            return getBrowserLanguage();
        }
    };

    const firstPath = location.pathname.substring(1, location.pathname.indexOf("/",2));
    const lang = firstPath === 'en' || firstPath === 'ch' ? firstPath : cookieLanguage ?? 'ch';
    return lang;
};

export const clearBetLineOddsUpdTs = (item) => {
    if (item.betObj.betType == 'ALUP') {
        item.betObj.betList = item.betObj.betList.map((betItem) => {
            betItem.combs = betItem.combs.map((comb) => {
                return {
                    ...comb,
                    oddsUpdTs: undefined
                };
            });

            return betItem;
        });
    } else {
        item.betObj.combs = item.betObj.combs.map((comb) => {
            return {
                ...comb,
                oddsUpdTs: undefined
            };
        });
    }

    return {
        ...item
    }
};